var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "level" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "level-right" }, [
          _c("div", { staticClass: "level-item" }, [
            _vm.canEditSlots
              ? _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button ml-4",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.addDateForm.showing = !_vm.addDateForm.showing
                          }
                        }
                      },
                      [_vm._m(1), _vm._v(" "), _c("span", [_vm._v("Add Date")])]
                    )
                  ])
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.schedulingHasStarted
        ? _c("p", [
            _vm._v(
              "\n    Scheduling has started. Dates and times are no longer editable.\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.addDateForm.showing && _vm.canEditSlots
        ? _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-4" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.addDate($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "field" }, [
                    _c("p", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.addDateForm.slots_date,
                            expression: "addDateForm.slots_date"
                          }
                        ],
                        staticClass: "input",
                        attrs: { type: "date", required: "" },
                        domProps: { value: _vm.addDateForm.slots_date },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.addDateForm,
                              "slots_date",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field" }, [
                    _c("p", { staticClass: "control" }, [
                      _c(
                        "button",
                        { staticClass: "button", attrs: { type: "submit" } },
                        [_vm._v("Add Date")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button is-text",
                          attrs: { type: "button" },
                          on: { click: _vm.closeAddDateForm }
                        },
                        [_vm._v("\n              Cancel\n            ")]
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.slotKeys, function(meetingDate) {
        return _c("section", { key: meetingDate, staticClass: "my-8" }, [
          _c("h3", { staticClass: "subtitle is-5" }, [
            _vm._m(2, true),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.formatDate(meetingDate)))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c("table", { staticClass: "table is-hoverable is-fullwidth" }, [
              _vm._m(3, true),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.meeting.appointment_slots[meetingDate], function(
                  timeslot,
                  index
                ) {
                  return _c("tr", { key: meetingDate + "-" + index }, [
                    _c("td", [_vm._v(_vm._s(timeslot.start_time))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(timeslot.end_time))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm.canEditSlots
                        ? _c("p", { staticClass: "control has-text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "button is-danger is-small is-outlined",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.confirmDeleteTimeSlot(
                                      meetingDate,
                                      timeslot
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "far fa-trash-alt" })]
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _vm.canEditSlots
              ? _c("div", { staticClass: "level" }, [
                  _c("div", { staticClass: "level-left" }, [
                    _vm.addSlotForm.showing === meetingDate
                      ? _c("div", [
                          _c(
                            "form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.addTimeSlot(meetingDate)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "field is-horizontal" },
                                [
                                  _c("div", { staticClass: "field-body" }, [
                                    _c("div", { staticClass: "field" }, [
                                      _c("p", { staticClass: "control" }, [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "date-label",
                                            attrs: { for: "startTime" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        Start:\n                      "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.addSlotForm.start_time,
                                              expression:
                                                "addSlotForm.start_time"
                                            }
                                          ],
                                          attrs: {
                                            type: "time",
                                            id: "startTime",
                                            "input-classes": "input is-small",
                                            placeholder: "Start"
                                          },
                                          domProps: {
                                            value: _vm.addSlotForm.start_time
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.addSlotForm,
                                                "start_time",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "field" }, [
                                      _c("p", { staticClass: "control" }, [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "date-label",
                                            attrs: { for: "endTime" }
                                          },
                                          [_vm._v(" End: ")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.addSlotForm.end_time,
                                              expression: "addSlotForm.end_time"
                                            }
                                          ],
                                          attrs: {
                                            type: "time",
                                            id: "endTime",
                                            "input-classes": "input is-small",
                                            placeholder: "End"
                                          },
                                          domProps: {
                                            value: _vm.addSlotForm.end_time
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.addSlotForm,
                                                "end_time",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "field is-grouped" },
                                      [
                                        _vm._m(4, true),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "control" }, [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "button is-small is-text",
                                              attrs: { type: "button" },
                                              on: {
                                                click: _vm.closeAddSlotForm
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        Cancel\n                      "
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ])
                      : _c("p", { staticClass: "control" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-small",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.openAddSlotForm(meetingDate)
                                }
                              }
                            },
                            [
                              _vm._m(5, true),
                              _vm._v(" "),
                              _c("span", [_vm._v("Add Time Slot")])
                            ]
                          )
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "level-right" }, [
                    _c("div", { staticClass: "field is-grouped" }, [
                      _c("p", { staticClass: "control" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-text",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.confirmDeleteDate(meetingDate)
                              }
                            }
                          },
                          [_c("span", [_vm._v("Delete")])]
                        )
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.canEditSlots
              ? _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-small",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.openCopySlotForm(meetingDate)
                          }
                        }
                      },
                      [
                        _vm._m(6, true),
                        _vm._v(" "),
                        _c("span", [_vm._v("Copy To New Date")])
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal",
              class: { "is-active": _vm.copyDateForm.showing }
            },
            [
              _c("div", { staticClass: "modal-background" }),
              _vm._v(" "),
              _c("div", { staticClass: "modal-card" }, [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.closeCopySlotForm($event)
                      }
                    }
                  },
                  [
                    _c("header", { staticClass: "modal-card-head" }, [
                      _c("p", { staticClass: "modal-card-title" }, [
                        _vm._v("Copying Timeslots To New Date")
                      ]),
                      _vm._v(" "),
                      _c("button", {
                        staticClass: "delete",
                        attrs: { "aria-label": "close" },
                        on: { click: _vm.closeCopySlotForm }
                      })
                    ]),
                    _vm._v(" "),
                    _c("section", { staticClass: "modal-card-body pd-2" }, [
                      _c("p", { staticClass: "control" }, [
                        _vm._v(
                          "\n              Copying all " +
                            _vm._s(_vm.copyMeetingSlotLength) +
                            " slots from\n              " +
                            _vm._s(
                              _vm.formatDate(_vm.copyDateForm.sourceDate)
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Enter New Date:")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.copyDateForm.targetDate,
                                expression: "copyDateForm.targetDate"
                              }
                            ],
                            staticClass: "input",
                            attrs: { type: "date", required: "required" },
                            domProps: { value: _vm.copyDateForm.targetDate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.copyDateForm,
                                  "targetDate",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("footer", { staticClass: "modal-card-foot" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-success",
                          on: { click: _vm.copySlotToDate }
                        },
                        [_vm._v("\n              Copy Schedule\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button is-text",
                          on: { click: _vm.closeCopySlotForm }
                        },
                        [_vm._v("\n              Cancel\n            ")]
                      )
                    ])
                  ]
                )
              ])
            ]
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "level-left" }, [
      _c("div", { staticClass: "level-item" }, [
        _c("p", { staticClass: "title is-4" }, [
          _vm._v("\n          Appointment Times\n        ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-plus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "far fa-calendar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Start Time")]),
        _vm._v(" "),
        _c("th", [_vm._v("End Time")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "control" }, [
      _c(
        "button",
        {
          staticClass: "button is-small is-primary",
          attrs: { type: "submit" }
        },
        [_vm._v("\n                        Add\n                      ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-plus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-plus" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-079676eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-079676eb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/meeting/AppointmentTimes.vue
// module id = null
// module chunks = 